<template>
  <v-app>
    <v-main style="background-color: rgb(173,46,27);">
      <!-- 点检系统视差图 -->
      <v-img src="../assets/视差图.png"></v-img>
      <v-container>
        <!-- 点检系统状态卡片栏 -->
        <v-card height="120" style="background-color:rgb(255, 255, 255)" class="mb-3">
          <v-card-subtitle class="mb-0">系统状态</v-card-subtitle>
          <v-card-text style="color: blue; align-items: center; font-size:20px;" align="center" class="mb-0">
            <v-chip small label color="transparent" style="font-size: 20px; color: #4cb29b; font-weight: bolder;">{{
              status }}</v-chip>
            <div style="color: darkgray; font-size: 12px;">{{ currentTime }}</div>
          </v-card-text>
        </v-card>
        <!-- 点检系统点检填报操作入口栏 -->
        <v-card style="background-color:rgb(255, 255, 255);" class="mt-3">
          <v-card-subtitle class="mb-0 mt-0">操作入口</v-card-subtitle>
          <v-container align="center">
            <v-card height="100" style="background-color: rgba(83,160,237,0.3);" class="mb-3">
              <v-card-subtitle class="mb-0"
                style="font-size:18px; color: black; font-weight: 530;">通用点检模板</v-card-subtitle>
              <div>
                <div class="d-flex justify-space-between">
                  <v-chip small label color="transparent" style="color: rgb(132, 132, 132);">请巡查人员按照要求实际填写</v-chip>
                  <v-btn small depressed color="primary" class="mr-3" to="/abnormalView">填报</v-btn>
                </div>
              </div>
            </v-card>
            <v-card height="100" style="background-color: rgba(251, 128, 128, 0.2);" class="mb-3">
              <v-card-subtitle class="mb-0"
                style="font-size:18px; color: black; font-weight: 530;">点检灭火器</v-card-subtitle>
              <div class="d-flex justify-space-between">
                <v-chip small label color="transparent" style="color: rgb(132, 132, 132);">请巡查人员按照要求实际填写</v-chip>
                <v-btn small depressed color="#d63939" class="mr-3" to="/fireExtinguisher" style="color: #fff;">
                  填报
                </v-btn>
              </div>
            </v-card>
            <v-card height="100" style="background-color: rgba(251, 128, 128, 0.2);" class="mb-3">
              <v-card-subtitle class="mb-0"
                style="font-size:18px; color: black; font-weight: 530;">点检消防栓</v-card-subtitle>
              <div class="d-flex justify-space-between">
                <v-chip small label color="transparent" style="color: rgb(132, 132, 132);">请巡查人员按照要求实际填写</v-chip>
                <v-btn small depressed color="#d63939" class="mr-3" to="/fireHydrant" style="color: #fff;">
                  填报
                </v-btn>
              </div>
            </v-card>

            <v-card height="100" style="background-color:  rgba(241, 156, 55, 0.1);" class="mb-3">
              <v-card-subtitle class="mb-0"
                style="font-size:18px; color: black; font-weight: 530;">点检烟感报警器</v-card-subtitle>
              <div class="d-flex justify-space-between">
                <v-chip small label color="transparent" style="color: rgb(132, 132, 132);">请巡查人员按照要求实际填写</v-chip>
                <v-btn small depressed color="#e0800f" class="mr-3" to="/smoke" style="color: #fff;">
                  填报
                </v-btn>
              </div>
            </v-card>
          </v-container>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'AbnormalHome',
  data() {
    return {
      currentTime: '',
      lastTime: '',
      status: "正常",

      fromdata: {
        sumNumber: 0,
        monthNumber: 0,
      }
    }
  },
  mounted() {
    this.updateTime()
    setInterval(this.updateTime, 1000)
  },
  methods: {
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
      const day = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
      const hours = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
      const minutes = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
      const seconds = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
      const week = now.getDay() // 星期
      const weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekArr[week]}`
    },
    homeSumNumber() {
      this.fromdata.sumNumber = this.$axios.get('').then(response => {
        console.log('响应数据:', response.data);
      })
        .catch(error => {
          alert("请求失败！");
          console.error('请求失败:', error)
        })
    },
    homeMonthNumber() {
      this.fromdata.monthNumber = this.$axios.get('').then(response => {
        console.log('响应数据:', response.data);
      })
        .catch(error => {
          alert("请求失败！");
          console.error('请求失败:', error)
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}  
</script>